/*
 * Silk Romance - Event Manager (theme-owned, Phase 8)
 *
 * This file is a single, lightweight, theme-owned event bus used by every
 * Phase 1-5 feature so no duplicate event systems are created.
 *
 * Events are pushed to window.dataLayer (created if absent, so this is
 * compatible with GTM/GA4 if/when a container is added) and logged to
 * console when ?sr_debug=1 is present in the URL. No PII beyond what the
 * customer explicitly submitted in a given flow is ever sent to a third party
 * from this file - it only writes to window.dataLayer locally.
 *
 * 2026-10-04: the Spin & Win funnel events (and ONLY those) are also handed to
 * Shopify's Web Pixels bridge, so the store's custom pixel can forward them to
 * the CRM and the owner can see how many visitors see the popup, enter a number
 * and spin. Only an allow-listed, PII-free subset of each payload (source,
 * prize_id) is published - never the mobile number, name or discount code.
 *
 * The storefront exposes the bridge as Shopify.analytics.publish(name, data)
 * (publishCustomEvent is NOT defined on this storefront - the first version of
 * this change called it and silently sent nothing). The bridge boots slightly
 * after the page, so a failed publish is retried a few times before giving up.
 * If the bridge never appears this is a silent no-op.
 *
 * 2026-10-04: also loads three capture/merchandising scripts - assets/sr-cart-contact.js
 * (cart "5% off + updates on WhatsApp" card and the after-add number pop-up),
 * assets/sr-capture-pack.js (Notify me, Spin & Win extras, exit offer) and
 * assets/sr-color-match.js (colour-matched saree suggestions in the cart) - see the
 * loader at the bottom. Delete that block to switch all three off.
 */
(function (window) {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  var DEBUG = /[?&]sr_debug=1/.test(window.location.search);

  var PIXEL_EVENTS = {
    spin_viewed: 1, spin_closed: 1, mobile_submitted: 1,
    spin_started: 1, spin_completed: 1, coupon_applied: 1
  };

  function publishToPixel(eventName, data, triesLeft) {
    try {
      var a = window.Shopify && window.Shopify.analytics;
      var fn = a && (typeof a.publish === 'function' ? a.publish : (typeof a.publishCustomEvent === 'function' ? a.publishCustomEvent : null));
      if (fn) {
        fn.call(a, eventName, data);
        if (DEBUG && window.console && console.log) console.log('[SR Event] published to pixel', eventName, data);
        return;
      }
    } catch (e) { /* analytics must never break the storefront */ }
    if (triesLeft > 0) {
      window.setTimeout(function () { publishToPixel(eventName, data, triesLeft - 1); }, 1000);
    }
  }

  function track(eventName, payload) {
    var entry = Object.assign({ event: eventName, sr_ts: new Date().toISOString() }, payload || {});
    window.dataLayer.push(entry);
    if (DEBUG && window.console && console.log) {
      console.log('[SR Event]', eventName, entry);
    }
    window.dispatchEvent(new CustomEvent('sr:event', { detail: entry }));

    if (PIXEL_EVENTS[eventName]) {
      publishToPixel(eventName, {
        source: (payload && payload.source) || null,
        prize_id: (payload && payload.prize_id) || null
      }, 5);
    }
  }

  window.SREvents = { track: track };

  // Capture scripts loader (2026-10-04). Skipped on the password page. The version query is the current hour plus a REV tag:
  // the hour keeps edits reaching visitors within the hour, and REV is bumped by hand whenever a script is edited so the CDN
  // cannot keep serving the previous copy under the old URL.
  try {
    var self = document.currentScript;
    if (self && self.src && !/\/password/.test(window.location.pathname)) {
      var base = self.src.split('?')[0].replace(/sr-events\.js$/, '');
      var REV = 'r5';
      var v = '?v=' + Math.floor(Date.now() / 3600000) + REV;
      ['sr-cart-contact.js', 'sr-capture-pack.js', 'sr-color-match.js'].forEach(function (f) {
        var s = document.createElement('script');
        s.src = base + f + v;
        s.defer = true;
        document.head.appendChild(s);
      });
    }
  } catch (e) { /* never break the storefront */ }
})(window);
